module.exports = __webpack_public_path__ + "static/media/car6.b1508805.jpg";